module.exports = __webpack_public_path__ + "img/vertical_1_1_8023.e60a8821.png";